export const customersRoute = (customerId: string, route?: string) =>
  route ? `/customers/${customerId}/${route}` : `/customers/${customerId}`;
